import type { PpnRole } from "./PpnRole"

const isRoleGroup = (group: string, role: PpnRole): boolean => group === role || group.endsWith(`_${role}`)

export const hasPpnRole = (ppnGroups: string | undefined, role: PpnRole): boolean =>
	(ppnGroups?.split(",") ?? []).some((group) => isRoleGroup(group.trim(), role))
